import { render, staticRenderFns } from "./comparator.vue?vue&type=template&id=63e6bbea&scoped=true&"
import script from "./comparator.vue?vue&type=script&lang=js&"
export * from "./comparator.vue?vue&type=script&lang=js&"
import style0 from "./comparator.vue?vue&type=style&index=0&id=63e6bbea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e6bbea",
  null
  
)

component.options.__file = "comparator.vue"
export default component.exports